//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Tries to lock document with the current client session or prolong existing lock.
If document is already locked with another session, throws ValidationException.
 * @param documentId (optional) 
 */
export function lock(documentId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RefDocumentEditingUserDto> {
    let url_ = getBaseUrl() + "/api/editing-lock/lock?";
    if (documentId === null)
        throw new Error("The parameter 'documentId' cannot be null.");
    else if (documentId !== undefined)
        url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigLock,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigLock?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processLock(_response);
    });
}

function processLock(response: AxiosResponse): Promise<Types.RefDocumentEditingUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRefDocumentEditingUserDto(resultData200);
        return Promise.resolve<Types.RefDocumentEditingUserDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RefDocumentEditingUserDto>(null as any);
}

/**
 * Tries to lock document with the current client session.
If document is already locked with another session, unlocks document and locks it again with the current session.
 * @param documentId (optional) 
 * @param deleteSharePointFileIfPresent (optional) 
 */
export function relock(documentId?: number | undefined, deleteSharePointFileIfPresent?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RefDocumentEditingUserDto> {
    let url_ = getBaseUrl() + "/api/editing-lock/relock?";
    if (documentId === null)
        throw new Error("The parameter 'documentId' cannot be null.");
    else if (documentId !== undefined)
        url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
    if (deleteSharePointFileIfPresent === null)
        throw new Error("The parameter 'deleteSharePointFileIfPresent' cannot be null.");
    else if (deleteSharePointFileIfPresent !== undefined)
        url_ += "deleteSharePointFileIfPresent=" + encodeURIComponent("" + deleteSharePointFileIfPresent) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRelock,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigRelock?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRelock(_response);
    });
}

function processRelock(response: AxiosResponse): Promise<Types.RefDocumentEditingUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRefDocumentEditingUserDto(resultData200);
        return Promise.resolve<Types.RefDocumentEditingUserDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RefDocumentEditingUserDto>(null as any);
}

/**
 * Tries to unlock document locked by the current client session.
If document is locked by another session, throws ValidationException.
 * @param documentId (optional) 
 */
export function unlock(documentId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RefDocumentEditingUserDto> {
    let url_ = getBaseUrl() + "/api/editing-lock?";
    if (documentId === null)
        throw new Error("The parameter 'documentId' cannot be null.");
    else if (documentId !== undefined)
        url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUnlock,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigUnlock?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUnlock(_response);
    });
}

function processUnlock(response: AxiosResponse): Promise<Types.RefDocumentEditingUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRefDocumentEditingUserDto(resultData200);
        return Promise.resolve<Types.RefDocumentEditingUserDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RefDocumentEditingUserDto>(null as any);
}

export function checkLock(documentId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RefDocumentEditingUserDto> {
    let url_ = getBaseUrl() + "/api/editing-lock?";
    if (documentId === null)
        throw new Error("The parameter 'documentId' cannot be null.");
    else if (documentId !== undefined)
        url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCheckLock,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigCheckLock?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCheckLock(_response);
    });
}

function processCheckLock(response: AxiosResponse): Promise<Types.RefDocumentEditingUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRefDocumentEditingUserDto(resultData200);
        return Promise.resolve<Types.RefDocumentEditingUserDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RefDocumentEditingUserDto>(null as any);
}
let _requestConfigLock: Partial<AxiosRequestConfig> | null;
export function getLockRequestConfig() {
  return _requestConfigLock;
}
export function setLockRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigLock = value;
}
export function patchLockRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigLock = patch(_requestConfigLock ?? {});
}

let _requestConfigRelock: Partial<AxiosRequestConfig> | null;
export function getRelockRequestConfig() {
  return _requestConfigRelock;
}
export function setRelockRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRelock = value;
}
export function patchRelockRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRelock = patch(_requestConfigRelock ?? {});
}

let _requestConfigUnlock: Partial<AxiosRequestConfig> | null;
export function getUnlockRequestConfig() {
  return _requestConfigUnlock;
}
export function setUnlockRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUnlock = value;
}
export function patchUnlockRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUnlock = patch(_requestConfigUnlock ?? {});
}

let _requestConfigCheckLock: Partial<AxiosRequestConfig> | null;
export function getCheckLockRequestConfig() {
  return _requestConfigCheckLock;
}
export function setCheckLockRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCheckLock = value;
}
export function patchCheckLockRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCheckLock = patch(_requestConfigCheckLock ?? {});
}